import { observer } from 'mobx-react-lite';
import { View, ViewStyle } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { style } from './BottomSheetAvoidCuts.style';
import { TestIDs } from 'src/constants/testIDs.constants';
import { bottomSheetTestID } from 'src/helpers/testIDs.helper';
import { neutrals } from 'src/theme/colors';
import { CircularButton } from '../buttons/circular-button/CircularButton';
import { CIRCULAR_BUTTON_SIZES, CIRCULAR_BUTTON_TYPES } from '../buttons/circular-button/CircularButton.constants';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { ICON_NAMES } from '../icon/icon.helper';
import TextLato from '../text/text-lato/TextLato';
import { FormatCard } from '../modals/dynamic-modals/modal-configuration-steps/steps/step-cards/FormatCard';
import { BottomSheetScrollView } from '@gorhom/bottom-sheet';

export const BottomSheetAvoidCuts = observer(({ bsStyle }: { bsStyle: ViewStyle }) => {
  const {
    i18n,
    bottomSheet: { closeBottomSheet, suggestedFormatCard, bottomSheetData },
  } = useStore();

  return (
    <BottomSheetScrollView contentContainerStyle={bsStyle}>
      <View style={style.container}>
        <View style={style.header}>
          <TextLato style={style.title}>{i18n.t('bottom-sheet-avoid-cuts:title')}</TextLato>
          <CircularButton
            onPress={async () => closeBottomSheet()}
            accessible={true}
            accessibilityLabel={i18n.t('actions:close_x', { x: '' })}
            accessibilityRole="button"
            iconName={ICON_NAMES.Close}
            iconStyle={{ color: neutrals.neutralGrays.ash }}
            size={CIRCULAR_BUTTON_SIZES.SMALL}
            type={CIRCULAR_BUTTON_TYPES.ONLY_ICON}
            testID={bottomSheetTestID(TestIDs.CLOSE)}
            focusId={bottomSheetTestID(TestIDs.CLOSE)}
            focusOrder={0}
            focusGroup={FocusGroups.BOTTOM_SHEET}
          />
        </View>
        <TextLato style={style.text}>{i18n.t('bottom-sheet-avoid-cuts:description')}</TextLato>
        <FormatCard
          item={suggestedFormatCard}
          index={0}
          onPress={() => {}}
          onFocus={() => {}}
          productGroup={bottomSheetData.productGroup}
        />
      </View>
    </BottomSheetScrollView>
  );
});
